import { makeStyles } from '@material-ui/core/styles';

import { TABLE_NAVIGATION_HEIGHT, TABLE_SCROLLBAR_HEIGHT } from './constants';

export const useStyles = makeStyles(theme => ({
	titleText: {
		display: 'inline-block',
		marginLeft: theme.spacing(1),
		whiteSpace: 'nowrap'
	},
	additionalActionsContainer: {
		display: 'inline-flex',
		width: 'auto',
		textAlign: 'left'
	},
	scrollBarContainer: {
		position: 'sticky',
		top: TABLE_NAVIGATION_HEIGHT,
		zIndex: 1050,
		backgroundColor: 'white',
		height: TABLE_SCROLLBAR_HEIGHT,
		[theme.breakpoints.down('sm')]: {
			display: 'none'
		}
	},
	scrollBarTrack: {
		position: 'relative',
		width: '100%',
		height: '100%',
		backgroundColor: '#f0f0f0',
		borderRadius: 6,
		cursor: 'pointer'
	},
	scrollBarThumb: {
		position: 'absolute',
		top: 0,
		left: 0,
		height: '100%',
		backgroundColor: '#bbb',
		borderRadius: 6,
		cursor: 'grab',
		touchAction: 'none',
		'&:hover': {
			backgroundColor: '#999'
		},
		'&:active': {
			cursor: 'grabbing',
			backgroundColor: '#777'
		}
	}
}));
